export default "__VITE_ASSET__Bfc_vwuV__"